import * as conflicts from './entities-conflicts.js'
import { entitiesSlice } from './entities-slice.js'
import * as thunks from './entities-thunks.js'

export type { EntityConflict } from './entities-slice.js'

export const entitiesFeature = { thunks, conflicts, actions: entitiesSlice.actions }
